// extracted by mini-css-extract-plugin
export default {"button":"cancel-subscription_button__NCmu4"};